/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// actions
import { displayMessage, removeMessage, displayModal } from '@insticator/insticator-ui'; // iui-state
import { handleDashboardMessage } from 'utils/messages';
// component
import Dashboard from 'pages/dashboard/dashboard';



/* ========== ~~~~~~~~~~ DASHBOARD : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus, messageStatus }) => ({
	sessionStatus,
	mocked: sessionStatus.mocked,
	messageStatus: messageStatus,
    preferredPaymentType: accountData.preferredPaymentType,
    savedPaymentTypes: accountData.savedPaymentTypes,
    paymentInfoPermitted: !sessionStatus.mocked && sessionStatus.permissions.includes('settings.paymentInfo'),
    paymentInfoReceived: accountData.paymentInfoReceived,
    accountName: accountData.accountName
});
// map actions
const mapDispatchToProps = dispatch => ({
	displayMessage: message => dispatch(displayMessage(message)),
	removeMessage: (filterProp, filterVal, messageType, alignment) => dispatch(removeMessage(filterProp, filterVal, messageType, alignment)),
	handleDashboardMessage: message => dispatch(handleDashboardMessage()),
	displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard));
